export enum EntityType {
  Trader,
  Supplier,
  Consumer,
}
